import { Component, OnInit, Input } from '@angular/core';



import { Resumen } from '../../../modelos/modelo-resumen';
import { ResumenService } from '../../../services/resumen.service';

import { Document, Packer, Paragraph } from 'docx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css']
})
export class DetalleComponent implements OnInit {

  panelOpenState = false;

  @Input() resumen: Resumen;

  constructor(private resumenService: ResumenService) { }

  ngOnInit() {
  }

  updateActive(isActive: boolean) {
    this.resumenService.updateResumen(this.resumen.key, { active: isActive });
  }

  deleteResumen() {
    this.resumenService.deleteResumen(this.resumen.key);
  }


  generate3(archivo: string,
            titulo: string,
            autores: string,
            filiacion: string,
            introducion: string,
            objetivo: string,
            metodo: string,
            resultado: string,
            conclusion: string,
            palabras: string) {
      const doc = new Document();

      doc.createParagraph(titulo).heading1().center();
      doc.createParagraph(autores).heading3().center();
      doc.createParagraph(filiacion).heading5().center();
      doc.createParagraph();
      doc.createParagraph('Resumen').heading2();
      doc.createParagraph();
      doc.createParagraph('Introducción').heading2();
      doc.createParagraph(introducion);
      doc.createParagraph();
      doc.createParagraph('Objetivo general').heading2();
      doc.createParagraph(objetivo);
      doc.createParagraph();
      doc.createParagraph('Métodos').heading2();
      doc.createParagraph(metodo);
      doc.createParagraph();
      doc.createParagraph('Resultado y discusión').heading2();
      doc.createParagraph(resultado);
      doc.createParagraph();
      doc.createParagraph('Conclusión').heading2();
      doc.createParagraph(conclusion);
      doc.createParagraph();
      doc.createParagraph('Palabras clave').heading2();
      doc.createParagraph(palabras);

      const packer = new Packer();
      packer.toBlob(doc).then(blob => {
      console.log(blob);
      saveAs(blob, archivo);
      console.log('Documento guardado.');
  });
  }

}
